import { setTotalUnread } from "../../../store/slices/notificationSlice";

export default function responseFetchHeaderNotifications(response: any, api: any, arg: any) {
    console.log('=== Header Notifications Response ===');
    console.log('Response:', response);

    // RTK Query wraps response in { data: ... } so we need to check both
    const data = response?.data || response;
    console.log('Data:', data);

    const totalUnread = data?.unreadCount ?? data?.totalUnread;
    console.log('totalUnread:', totalUnread);

    if (totalUnread !== undefined && totalUnread !== null) {
        api.dispatch(setTotalUnread(totalUnread));
    }

    // Get notifications from response
    const notifications = data?.notifications ?? data?.recentNotifications;
    console.log('notifications:', notifications);

    if (notifications && Array.isArray(notifications) && notifications.length > 0) {
        api.dispatch({
            type: 'notifications/addNotification',
            payload: notifications
        });
    }

    return response;
}
